<template>
  <v-list class="py-0 custom-scroll" :class="{'items-list-master' : splitOption, 'items-list' : !splitOption, 'custom-scroll--lg': settings.increaseScrollWidth}">
    <div v-for="(item, k) in items" :key="`item-${k}`" class="items">
      <v-list-tile
        class="py-1"
        @click="selectItem(item)"
        :class="{ 'primary white--text': item.id == selected }"
      >
        <v-list-tile-action class="subheading font-weight-bold item-qty--action">{{
          item.qty
        }}</v-list-tile-action>

        <v-list-tile-content class="subheading font-weight-bold">
          <v-list-tile-title>
            {{ item.name }}
            <span class="pr-4"></span>
          </v-list-tile-title>
          <v-list-tile-title>
            <template v-for="service in item.services">
              <span v-if="service.quantity > 0" class="pr-3" :key="service.name">
              <v-icon size="18" :color="item.id == selected ? 'white' : service.color"
                >{{service.icon}}</v-icon
              >
              &nbsp;({{ service.quantity }})
            </span>
            </template>
          </v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action
          class="subheading font-weight-bold"
          :class="{ 'success--text': item.id != selected }"
          >{{ item.acceptedQty }}</v-list-tile-action
        >
      </v-list-tile>
      <v-divider :key="`item-line-${k}`" v-if="k+1 != items.length"></v-divider>
    </div>
  </v-list>
</template>
<script>
export default {
  props: {
    items: {
      type: Array
    },
    selected: {
      type: Number
    },
    splitOption: Boolean,
    selectItem: Function
  },
  computed: {
    settings() {
      return this.$store.getters.nodeSettings;
    }
  }
};
</script>
